module.exports = __webpack_public_path__ + "img/homeBanner@2x.267b9301.png";